module.exports = __webpack_public_path__ + "static/media/ng04.6dc64fbe.webp";